export default __webpack_public_path__ + "static/media/Force of the Pillars.77a9bb1c.jpg";